/**
 * supabase/tasks.js — Sistema de tareas para CAPs
 * (getTasks/createTask/completeTask/deleteTask).
 * Parte de la fachada src/lib/supabase.js.
 */

import { getSupabase } from "./client";

// ═══════════════════════════════════════════════════
// TASKS — Sistema de tareas para CAPs
// ═══════════════════════════════════════════════════

export async function getTasks({ asesorId = null, includeCompleted = false } = {}) {
  const client = getSupabase();

  let query = client
    .from("tasks")
    .select(`*, lead:lead_id(id, nombre_tutor, telefono, nivel_educativo, estado_lead)`)
    .order("created_at", { ascending: false });

  if (asesorId) query = query.eq("asesor_id", asesorId);
  if (!includeCompleted) query = query.eq("completada", false);

  const { data, error } = await query;
  if (error) { console.warn("[tasks] getTasks error:", error.message); return { data: [], error }; }

  return {
    data: (data ?? []).map(t => ({
      ...t,
      lead_nombre: t.lead?.nombre_tutor || null,
      lead_telefono: t.lead?.telefono || null,
      lead_nivel: t.lead?.nivel_educativo || null,
      lead_estado: t.lead?.estado_lead || null,
    })),
    error: null,
  };
}

export async function createTask({ leadId, asesorId, titulo, descripcion, tipo = "manual", prioridad = "normal", fechaVencimiento = null }) {
  const client = getSupabase();
  const { data, error } = await client
    .from("tasks")
    .insert({
      lead_id: leadId || null,
      asesor_id: asesorId || null,
      titulo,
      descripcion: descripcion || null,
      tipo,
      prioridad,
      fecha_vencimiento: fechaVencimiento || null,
    })
    .select(`*, lead:lead_id(id, nombre_tutor, telefono, nivel_educativo, estado_lead)`)
    .single();

  if (error) { console.warn("[tasks] createTask error:", error.message); return { data: null, error }; }
  return { data, error: null };
}

export async function completeTask(taskId) {
  const client = getSupabase();
  const { data, error } = await client
    .from("tasks")
    .update({ completada: true, completada_at: new Date().toISOString() })
    .eq("id", taskId)
    .select()
    .single();

  if (error) { console.warn("[tasks] completeTask error:", error.message); return { data: null, error }; }
  return { data, error: null };
}

export async function deleteTask(taskId) {
  const client = getSupabase();
  const { error } = await client.from("tasks").delete().eq("id", taskId);
  if (error) { console.warn("[tasks] deleteTask error:", error.message); return { error }; }
  return { error: null };
}
